import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import * as MenuListUI from 'components/MenuList';
import Box from 'components/Box';
import PopoverCard from 'components/PopoverCard';
import { useComboboxContext } from './Combobox';
function ComboboxMenu(_ref) {
  var children = _ref.children,
    ariaLabel = _ref['aria-label'],
    minWidth = _ref.minWidth;
  var _useComboboxContext = useComboboxContext(),
    popover = _useComboboxContext.popover,
    itemList = _useComboboxContext.itemList,
    statusMessage = _useComboboxContext.statusMessage,
    shouldShowStatusMessage = _useComboboxContext.shouldShowStatusMessage;
  return /*#__PURE__*/React.createElement(PopoverCard, _extends({
    renderInPlace: true,
    renderWhenClosed: true,
    isOpen: popover.isOpen,
    minWidth: minWidth
  }, popover.props, {
    ref: popover.setRef,
    arrow: popover.arrow
  }), shouldShowStatusMessage ? /*#__PURE__*/React.createElement(Box, {
    px: "s",
    py: "xs"
  }, statusMessage) : /*#__PURE__*/React.createElement(MenuListUI.Wrapper, {
    role: "listbox",
    "aria-label": ariaLabel,
    id: itemList.listId,
    tabIndex: -1
  }, children));
}
export default ComboboxMenu;